import Colors from '@/constants/Colors';
import styled from 'styled-components';

export const StyledKaraokePlayer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  max-height: var(--appheight) !important;
  background-color: ${Colors.background};

  .mask-player {
    flex: 1;
    height: 0;
    width: 100%;
    position: relative;
    overflow-y: auto; /*${(props) => (props.showScroll ? 'auto' : 'hidden')}*/
    overflow-x: hidden;
    &::-webkit-scrollbar {
      display: ${(props) => (props.showScroll ? 'default' : 'none')};
    }
    .source-image {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      .to-be-masked {
        position: relative;
      }
      .onion-bg {
        width: 100%;
        height: 100%;
        opacity: 30%;
        position: absolute;
        top: 0;
        left: 0;
      }
    }
    .lyrics-comic {
      flex: 1;
      height: 0;
      width: 100%;
      overflow-y: hidden;
      overflow-x: hidden;
      .karaoke-row {
        position: relative;
        height: 250px;
        img {
          position: absolute;
          top: 0;
          left: 0;
          opacity: 0;
          &.past-layer {
            opacity: 0.3;
          }
          &.current-layer {
            opacity: 1;
          }
        }
      }
    }

    .player-wrapper {
      flex: 1;
      max-height: 100%;
    }
  }
`;
